import { makeStyles } from 'tss-react/mui';
import emojiFlags from 'emoji-flags';
import EasyEmoji from 'react-easy-emoji';

function svgEmoji(input, isFlag) {
  return EasyEmoji(input, code => {
    const useStyles = makeStyles()(() => ({
      roundEmoji: {
        backgroundImage: `url("/img/emoji/svg/${code}.svg")`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        backgroundSize: '200px 160px',
        width: isFlag ? 170 : 100,
        height: isFlag ? 150 : 100,
        borderRadius: isFlag ? 20 : 100,
        margin: 'auto',
      },
    }));
    const { classes } = useStyles();
    return <div className={classes.roundEmoji} />;
  });
}

export default function CountryEmoji({ countryCode, isFlag }) {
  return (
    <>
      {svgEmoji(
        emojiFlags.countryCode(countryCode.toUpperCase()).emoji,
        isFlag,
      )}
    </>
  );
}
